import { createContext } from "react"

import { TabState } from "./Tab.types"

export const TabContext = createContext<TabState>({
  activeKey: "",
  addItem: () => {},
})